export default __webpack_public_path__ + "static/ocean-5e3fdd79b8bf2b79e44a99381251ba75.png";